import { CardDeliveryBarSkeleton } from './Skeleton'
import { CardDeliveryStatus } from '@/src/common/components/CardDeliveryStatus'
import { VirtualCardApi } from '@/src/experiences/virtual-card/store'
import { ID } from '@acre-rewards/lib'
import * as CardAccounts from '@/src/experiences/card-accounts'
import { DesignSystem } from '@/src/design-system'

function CardDeliveryBar({ cardAccountId }: { cardAccountId: ID.CardAccount }) {
  const shipmentQuery = VirtualCardApi.endpoints['GET /card/:cardAccountId/shipment'].useQuery({
    params: { cardAccountId },
  })

  DesignSystem.ScreenWideReload.useReloadListener(async () => {
    await shipmentQuery.refetch()
  })

  if (shipmentQuery.isUninitialized || shipmentQuery.isLoading) {
    return <CardDeliveryBarSkeleton />
  }

  if (shipmentQuery.error || shipmentQuery.data?.status === 'ACTIVE') {
    return null
  }

  return (
    <CardDeliveryStatus
      trackingNumber={shipmentQuery.data?.trackingNumber}
      status={(() => {
        switch (shipmentQuery.data?.status) {
          case 'PENDING_FULFILLMENT':
            return 'PRINTED'
          case 'PENDING_ACTIVATION':
            return 'SHIPPED'
          default:
            return 'SUBMITTED'
        }
      })()}
    />
  )
}

export function CardDeliveryBarPlatform() {
  const firstCardAccount = CardAccounts.Hooks.useGetFirstAccount()

  if (firstCardAccount.isLoading) {
    return <CardDeliveryBarSkeleton />
  }

  if (!firstCardAccount.data?.id) {
    return null
  }

  return <CardDeliveryBar cardAccountId={firstCardAccount.data.id} />
}
